// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* PrismJS 1.27.0
https://prismjs.com/download.html#themes=prism&languages=markup+css+clike+javascript */

code[class*=language-],
pre[class*=language-] {
	color: #000;
	background: 0 0;
	text-shadow: 0 1px #fff;
	font-family: Consolas, Monaco, 'Andale Mono', 'Ubuntu Mono', monospace;
	font-size: 1em;
	text-align: left;
	white-space: pre;
	word-spacing: normal;
	word-break: normal;
	word-wrap: normal;
	line-height: 1.5;
	tab-size: 4;
	hyphens: none
}

code[class*=language-] ::selection,
code[class*=language-]::selection,
pre[class*=language-] ::selection,
pre[class*=language-]::selection {
	text-shadow: none;
	background: #b3d4fc
}

@media print {
	code[class*=language-],
	pre[class*=language-] {
		text-shadow: none
	}
}

pre[class*=language-] {
	padding: 1em;
	margin: .5em 0;
	overflow: auto
}

:not(pre)>code[class*=language-],
pre[class*=language-] {
	background: #f5f2f0
}

:not(pre)>code[class*=language-] {
	padding: .1em;
	border-radius: .3em;
	white-space: normal
}

.token.cdata,
.token.comment,
.token.doctype,
.token.prolog {
	color: #708090
}

.token.punctuation {
	color: #999
}

.token.namespace {
	opacity: .7
}

.token.boolean,
.token.constant,
.token.deleted,
.token.number,
.token.property,
.token.symbol,
.token.tag {
	color: #905
}

.token.attr-name,
.token.builtin,
.token.char,
.token.inserted,
.token.selector,
.token.string {
	color: #690
}

.language-css .token.string,
.style .token.string,
.token.entity,
.token.operator,
.token.url {
	color: #9a6e3a;
	background: hsla(0, 0%, 100%, .5)
}

.token.atrule,
.token.attr-value,
.token.keyword {
	color: #07a
}

.token.class-name,
.token.function {
	color: #dd4a68
}

.token.important,
.token.regex,
.token.variable {
	color: #e90
}

.token.bold,
.token.important {
	font-weight: 700
}

.token.italic {
	font-style: italic
}

.token.entity {
	cursor: help
}`, "",{"version":3,"sources":["webpack://./src/dist/css/prism.css"],"names":[],"mappings":"AAAA;sFACsF;;AAEtF;;CAEC,WAAW;CACX,eAAe;CACf,uBAAuB;CACvB,sEAAsE;CACtE,cAAc;CACd,gBAAgB;CAChB,gBAAgB;CAChB,oBAAoB;CACpB,kBAAkB;CAClB,iBAAiB;CACjB,gBAAgB;CAGhB,WAAW;CAIX;AACD;;AAUA;;;;CAIC,iBAAiB;CACjB;AACD;;AAEA;CACC;;EAEC;CACD;AACD;;AAEA;CACC,YAAY;CACZ,cAAc;CACd;AACD;;AAEA;;CAEC;AACD;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB;AACD;;AAEA;;;;CAIC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;;;;;;;CAOC;AACD;;AAEA;;;;;;CAMC;AACD;;AAEA;;;;;CAKC,cAAc;CACd;AACD;;AAEA;;;CAGC;AACD;;AAEA;;CAEC;AACD;;AAEA;;;CAGC;AACD;;AAEA;;CAEC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD","sourcesContent":["/* PrismJS 1.27.0\nhttps://prismjs.com/download.html#themes=prism&languages=markup+css+clike+javascript */\n\ncode[class*=language-],\npre[class*=language-] {\n\tcolor: #000;\n\tbackground: 0 0;\n\ttext-shadow: 0 1px #fff;\n\tfont-family: Consolas, Monaco, 'Andale Mono', 'Ubuntu Mono', monospace;\n\tfont-size: 1em;\n\ttext-align: left;\n\twhite-space: pre;\n\tword-spacing: normal;\n\tword-break: normal;\n\tword-wrap: normal;\n\tline-height: 1.5;\n\t-moz-tab-size: 4;\n\t-o-tab-size: 4;\n\ttab-size: 4;\n\t-webkit-hyphens: none;\n\t-moz-hyphens: none;\n\t-ms-hyphens: none;\n\thyphens: none\n}\n\ncode[class*=language-] ::-moz-selection,\ncode[class*=language-]::-moz-selection,\npre[class*=language-] ::-moz-selection,\npre[class*=language-]::-moz-selection {\n\ttext-shadow: none;\n\tbackground: #b3d4fc\n}\n\ncode[class*=language-] ::selection,\ncode[class*=language-]::selection,\npre[class*=language-] ::selection,\npre[class*=language-]::selection {\n\ttext-shadow: none;\n\tbackground: #b3d4fc\n}\n\n@media print {\n\tcode[class*=language-],\n\tpre[class*=language-] {\n\t\ttext-shadow: none\n\t}\n}\n\npre[class*=language-] {\n\tpadding: 1em;\n\tmargin: .5em 0;\n\toverflow: auto\n}\n\n:not(pre)>code[class*=language-],\npre[class*=language-] {\n\tbackground: #f5f2f0\n}\n\n:not(pre)>code[class*=language-] {\n\tpadding: .1em;\n\tborder-radius: .3em;\n\twhite-space: normal\n}\n\n.token.cdata,\n.token.comment,\n.token.doctype,\n.token.prolog {\n\tcolor: #708090\n}\n\n.token.punctuation {\n\tcolor: #999\n}\n\n.token.namespace {\n\topacity: .7\n}\n\n.token.boolean,\n.token.constant,\n.token.deleted,\n.token.number,\n.token.property,\n.token.symbol,\n.token.tag {\n\tcolor: #905\n}\n\n.token.attr-name,\n.token.builtin,\n.token.char,\n.token.inserted,\n.token.selector,\n.token.string {\n\tcolor: #690\n}\n\n.language-css .token.string,\n.style .token.string,\n.token.entity,\n.token.operator,\n.token.url {\n\tcolor: #9a6e3a;\n\tbackground: hsla(0, 0%, 100%, .5)\n}\n\n.token.atrule,\n.token.attr-value,\n.token.keyword {\n\tcolor: #07a\n}\n\n.token.class-name,\n.token.function {\n\tcolor: #dd4a68\n}\n\n.token.important,\n.token.regex,\n.token.variable {\n\tcolor: #e90\n}\n\n.token.bold,\n.token.important {\n\tfont-weight: 700\n}\n\n.token.italic {\n\tfont-style: italic\n}\n\n.token.entity {\n\tcursor: help\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
